import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/utils/cookie'
import roleObj from '~/utils/global'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

// 所有的角色列表
const allRoleList = [
  // 项目负责人
  roleObj.PROJECT_ADMIN,
  // 项目联系人
  roleObj.PROJECT_CONTACT,
  // 课题负责人
  roleObj.TOPIC_ADMIN,
  // 课题联系人
  roleObj.TOPIC_CONTACT,
  // 单位负责人
  roleObj.UNIT_ADMIN,
  // 单位联系人
  roleObj.UNIT_CONTACT,
  // 单位成员
  roleObj.MEMBER
]

/**
 * 因为某一类型的负责人和联系人权限是一样的
 * 为了简洁 合并在一起
 */
const projectRole = [
  roleObj.PROJECT_ADMIN,
  roleObj.PROJECT_CONTACT
]
const topicRole = [
  roleObj.TOPIC_ADMIN,
  roleObj.TOPIC_CONTACT
]
const unitRole = [
  roleObj.UNIT_ADMIN,
  roleObj.UNIT_CONTACT
]

const routes = [
  {
    path: '/404',
    component: () => import('../views/404.vue')
  },
  // 首页
  {
    path: '/',
    redirect: '/login'
  },
  // 登录
  {
    path: '/login',
    component: () => import('../views/login')
  },
  // 功能页
  {
    path: '/index',
    // 目前，一进入控制台 跳转到账号管理界面
    redirect: '/index/home',
    component: () => import('../views/index'),
    meta: {
      authentication: true,
      rules: allRoleList
    },
    /* beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      next('/login')
    }, */
    children: [
      {
        // 首页
        path: 'home',
        component: () => import('../views/index/home/index'),
        meta: {
          sidebar: '/index/home',
          authentication: true,
          rules: [...projectRole, ...topicRole, ...unitRole]
        }
      },
      {
        // 首页
        path: 'issue',
        component: () => import('../views/index/issue'),
        meta: {
          sidebar: '/index/issue',
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 项目动态
        path: 'activities',
        component: () => import('../views/index/activities'),
        meta: {
          sidebar: '/index/activities',
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 课题组管理
        path: 'topic',
        component: () => import('../views/index/topic'),
        meta: {
          sidebar: '/index/topic',
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 成员管理
        path: 'member',
        component: () => import('../views/index/member'),
        meta: {
          sidebar: '/index/member',
          authentication: true,
          rules: [...projectRole, ...topicRole, ...unitRole]
        }
      },
      {
        // 文档管理
        path: 'docs',
        component: () => import('../views/index/docs'),
        meta: {
          sidebar: '/index/docs',
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 资源管理
        path: 'resource/:id?',
        component: () => import('../views/index/resource'),
        props: true,
        meta: {
          sidebar: '/index/resource',
          authentication: true,
          rules: allRoleList
        }
      },
      /* {
        // 审核消息
        path: 'message',
        component: () => import('../views/index/message'),
        meta: {
          sidebar: '/index/message',
          authentication: true,
          rules: allRoleList
        }
      }, */
      {
        // 预算管理
        path: 'fund',
        component: () => import('../views/index/fund'),
        meta: {
          sidebar: '/index/fund',
          authentication: true,
          rules: [...projectRole, ...topicRole, ...unitRole]
        }
      },
      {
        // 通知管理
        path: 'notification',
        component: () => import('../views/index/notification/index.vue'),
        meta: {
          sidebar: '/index/notification',
          authentication: true,
          rules: projectRole
        }
      },
      {
        // 会议
        path: 'meeting',
        component: () => import('../views/index/meeting/index.vue'),
        meta: {
          sidebar: '/index/meeting',
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 【项目办身份可见】 成员审核
        path: 'checkMember',
        component: () => import('../views/index/checkMember'),
        meta: {
          sidebar: '/index/checkMember',
          authentication: true,
          onlyProjectoOffice: true,
          rules: allRoleList
        }
      },
      {
        // 【项目办身份可见】 预算修改
        path: 'updateFund',
        component: () => import('../views/index/upadteFund'),
        meta: {
          sidebar: '/index/updateFund',
          authentication: true,
          onlyProjectoOffice: true,
          rules: allRoleList
        }
      },
      {
        // 【项目办身份可见】 项目日志
        path: 'log',
        component: () => import('../views/index/log'),
        meta: {
          sidebar: '/index/log',
          authentication: true,
          onlyProjectoOffice: true,
          rules: allRoleList
        }
      }
    ]
  },
  // 外部的一些详情页等等
  {
    path: '/outer',
    // 目前，一进入控制台 跳转到账号管理界面
    component: () => import('../views/outer'),
    meta: {
      authentication: true,
      rules: allRoleList
    },
    children: [
      {
        // 账号管理
        path: 'account',
        component: () => import('../views/outer/account'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 添加议题
        path: 'issue/add',
        component: () => import('../views/outer/issue/add.vue'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 更新议题
        path: 'issue/update/:id',
        component: () => import('../views/outer/issue/update.vue'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 议题详情
        path: 'issue/details/:id',
        component: () => import('../views/outer/issue/details.vue'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 添加动态
        path: 'activities/add',
        component: () => import('../views/outer/activities/add.vue'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 动态详情
        path: 'activities/details/:id',
        component: () => import('../views/outer/activities/details.vue'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        /**
         * 单位管理
         * 1、新增成果
         * 2、报销开支
         * 3、编辑单位目标
         *    a、增加
         *    b、删除
         */
        // 成果记录及开支记录
        path: 'unit/logs/:id/:unitName',
        component: () => import('../views/outer/unit/logs'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 添加开支报销
        path: 'unit/addExpense',
        component: () => import('../views/outer/unit/expense/add.vue'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 报销详情
        path: 'unit/expenseDetails/:id',
        component: () => import('../views/outer/unit/expense/details.vue'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 添加成果
        path: 'unit/addAchievement/:unitId/:topicId/:achievementType/:achievementName',
        component: () => import('../views/outer/unit/achievement/achievement-create'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 添加成果
        path: 'unit/achievementDetails/:unitId/:id/:achievementType',
        component: () => import('../views/outer/unit/achievement/achievement-detail'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 编辑企业信息
        path: 'unit/edit',
        component: () => import('../views/outer/unit/edit'),
        meta: {
          authentication: true,
          rules: [...projectRole, ...topicRole, ...unitRole]
        }
      },
      {
        /**
         * 编辑课题
         * 1、编辑经费
         */
        path: 'topic/:id',
        component: () => import('../views/outer/topic'),
        meta: {
          authentication: true,
          rules: [...projectRole, ...topicRole]
        }
      },
      {
        /**
         * 编辑课题任务节点
         */
        path: 'topic/milestone/:id',
        component: () => import('../views/outer/topic/milestone'),
        meta: {
          authentication: true,
          rules: [...projectRole, ...topicRole]
        }
      },
      // 会议详情
      {
        path: 'meeting/:id',
        component: () => import('../views/outer/meeting/index.vue'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      // 编辑通知设置的高级配置
      {
        path: 'notification/setting',
        component: () => import('../views/outer/notification/setting.vue'),
        meta: {
          authentication: true,
          rules: allRoleList
        }
      },
      {
        // 【项目办身份可见】审核成员详情
        path: 'checkMember/details/:id',
        component: () => import('../views/outer/checkMember'),
        props: true,
        meta: {
          authentication: true,
          onlyProjectoOffice: true,
          rules: allRoleList
        }
      },
      {
        // 文件预览 所有人员可见
        path: 'previewFile',
        component: () => import('../views/outer/previewFile'),
        props: true,
        meta: {
          authentication: true,
          rules: allRoleList
        }
      }
    ]
  },
  // 当使用通配符路由时，请确保路由的顺序是正确的，也就是说含有通配符的路由应该放在最后
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  // cookie 中没有token 是： undefined "token" (undefined: 返回一个未定义的对象)
  let token = cookie.get('token')
  // localStorage 中没有baseinfo 是：  null "baseInfo" (null: 此处不应有值 没有对象)
  // 所以 baseInfo.role 会报错
  let baseInfoJsonStr = localStorage.getItem('baseInfo')
  // 如果需要身份验证
  if (to.meta.authentication) {
    // 必须登录
    if (token && baseInfoJsonStr) {
      // 用户角色
      let role = JSON.parse(localStorage.getItem('baseInfo')).role
      // 是否是项目办的身份
      let isOfficiale = Number(JSON.parse(localStorage.getItem('baseInfo')).is_official) === 1
      // 符合权限
      if (to.meta.rules.includes(role)) {
        // 如果必须是项目办身份才能进入
        if (to.meta.onlyProjectoOffice) {
          // 如果是项目办的身份就继续进入
          if (isOfficiale) {
            next()
          // 不是进入404页面
          } else {
            next('/404')
          }
        } else {
          next()
        }
      } else {
        next('/404')
      }
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js